import CampaignBudgetInfo from './CampaignBudgetInfo';

export default CampaignBudgetInfo;
